import { BaseModel } from '../baseModel';

/**
 * Enum used server-side to describe the type of an {@link OtherRate}.
 */
export enum OtherRateType {
  Supervision,
  Operator,
  Forklift,
  NPT,
  Break,
  Commission,
  Tarp,
  PickRateMin,
  PickRateMax,
}

/**
 * The server-side model for an default (i.e. 'other') rate.
 */
export type OtherRate = BaseModel & {
  id: number;
  type: OtherRateType;
  rate: number;
};

/**
 * Maps {@link OtherRateType} values to their display names.
 */
export const otherRateNames = {
  [OtherRateType.Supervision]: 'Supervision',
  [OtherRateType.Operator]: 'Operator',
  [OtherRateType.Forklift]: 'Forklift',
  [OtherRateType.NPT]: 'NPT',
  [OtherRateType.Break]: 'Break',
  [OtherRateType.Commission]: 'Commission',
  [OtherRateType.Tarp]: 'Tarp',
  [OtherRateType.PickRateMin]: 'Pick Min',
  [OtherRateType.PickRateMax]: 'Pick Max',
};

type MappedOtherRate = Pick<OtherRate, 'id' | 'rate'>;

/**
 * Maps an array of {@link OtherRate} to their {@link OtherRateType}.
 */
export function mapOtherRates(
  otherRates: OtherRate[],
): Map<OtherRateType, MappedOtherRate> {
  const otherRatesMap = new Map<OtherRateType, MappedOtherRate>();

  otherRates.reduce((acc, rate) => {
    acc.set(rate.type, {
      id: rate.id,
      rate: rate.rate,
    });

    return acc;
  }, otherRatesMap);

  return otherRatesMap;
}
